import React, { useState } from 'react';
import { ArrowLeft, Mail, Loader2, CheckCircle, AlertTriangle } from 'lucide-react';
import axios from 'axios';

import API from './apiConfig';

export default function ForgotPasswordPage({ onBack }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (e) {
      setError(e.response?.data?.detail || 'Fehler beim Senden.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4 relative">
      <button onClick={onBack} data-testid="forgot-back-btn"
        className="absolute top-6 left-6 flex items-center gap-2 text-zinc-500 hover:text-zinc-200 text-sm font-mono transition-colors">
        <ArrowLeft className="w-4 h-4" /> Zurück zum Login
      </button>
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="LAIzyBlueprint" className="h-14 mx-auto mb-3" />
          <h1 className="text-xl font-bold text-white font-mono tracking-wider">Passwort vergessen</h1>
          <p className="text-zinc-500 text-sm mt-2">
            Geben Sie Ihre E-Mail ein. Wir senden Ihnen einen Link zum Zurücksetzen.
          </p>
        </div>

        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-success">
            <div className="w-14 h-14 bg-green-500/10 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-7 h-7 text-green-400" />
            </div>
            <p className="text-zinc-300 text-sm font-mono">
              Falls ein Konto mit <span className="text-white font-medium">{email}</span> existiert, haben wir einen Reset-Link gesendet.
            </p>
            <p className="text-zinc-600 text-xs">Prüfen Sie auch Ihren Spam-Ordner. Der Link ist 1 Stunde gültig.</p>
            <button onClick={onBack} className="mt-4 text-blue-400 hover:text-blue-300 text-sm font-mono">
              Zurück zum Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-sm">
                <AlertTriangle className="w-4 h-4 flex-shrink-0" /> {error}
              </div>
            )}
            <div>
              <label className="block text-xs text-zinc-500 mb-1 font-mono">E-Mail-Adresse</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
                <input data-testid="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  placeholder="name@firma.de"
                  className="w-full pl-10 pr-3 py-2.5 bg-zinc-900 border border-zinc-700 rounded-lg text-white text-sm font-mono focus:border-blue-500 focus:outline-none" />
              </div>
            </div>
            <button data-testid="forgot-submit" type="submit" disabled={loading || !email.trim()}
              className="w-full py-2.5 bg-blue-600 hover:bg-blue-500 disabled:bg-zinc-700 text-white font-mono text-sm rounded-lg transition-colors flex items-center justify-center gap-2">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Senden...</> : 'Reset-Link senden'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
